import styled from 'styled-components';
import { blueLink, grey, grey10, grey25, grey50, navy, white } from '@zocdoc/branding/colors';
import { FontFamily } from '@zocdoc/components/src/typography';
import { Close } from '@zocdoc/components/src/icons';

export const FacetChip = styled.div`
    background-color: ${getFacetBackgroundColor};
    border-radius: 2px;
    border: 1px solid;
    border-color: ${p => p.isActive ? grey : grey50};
    color: ${p => p.showDropdown ? white : navy};
    cursor: pointer;
    display: flex;
    font: 13px ${FontFamily.SharpSansSemibold};
    margin-right: 12px;
    margin-top: 7px;
    white-space: nowrap;

    &:hover {
        background-color: ${p => p.showDropdown ? grey : grey10};
        color: ${p => p.showDropdown ? white : navy};
        text-decoration: none;
    }
`;

export const ClearAllOptionsButtonWrapper = styled.div`
    color: ${p => p.showDropdown ? white : grey};
    &:hover {
        color: ${p => p.showDropdown ? grey50 : navy};
    }
`;

export const ClearAllOptionsButton = styled(Close)`
    font: 14px ${FontFamily.SharpSansSemibold};
    width: 7px;
    height: 8px;
    margin-left: 1px;
    margin-right: 9px;
    margin-top: 11px;
    white-space: nowrap;

    &:hover {
        cursor: pointer;
    }
`;

export const FacetChipText = styled.div`
    max-width: 200px;
    overflow: hidden;
    padding: 7px 12px 7px;
    padding-right: ${p => p.addCloseButtonPadding ? '6px' : ''};
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const OptionCount = styled.div`
    color: ${grey};
    flex-grow: 1;
    font: 13px ${FontFamily.SharpSansMedium};
    margin-top: 2px;
    padding-left: 30px;
    text-align: right;
`;

export const ApplySection = styled.div`
    border-top: solid 1px ${grey25};
    display: flex;
    flex: 0 0 auto;
    justify-content: space-between;
    margin-top: 10px;
    padding: 12px 16px;
`;

export const ApplyButton = styled.div`
    color: ${blueLink};
    cursor: pointer;
    font: 15px ${FontFamily.SharpSansSemibold};
`;

export const ClearButton = styled.div`
    color: ${blueLink};
    cursor: ${p => p.disabled ? 'default' : 'pointer'};
    display: ${p => p.disabled ? 'none' : ''};
    font: 15px ${FontFamily.SharpSansSemibold};
`;

function getFacetBackgroundColor(props) {
    const {
        isActive,
        selectionRequired,
        showDropdown,
    } = props;

    if (showDropdown) {
        return grey;
    } else if (isActive || selectionRequired) {
        return grey25;
    } else {
        return white;
    }
}
